import { render, staticRenderFns } from "./tradeStock.vue?vue&type=template&id=663d36bd"
import script from "./tradeStock.vue?vue&type=script&lang=js"
export * from "./tradeStock.vue?vue&type=script&lang=js"
import style0 from "./tradeStock.vue?vue&type=style&index=0&id=663d36bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports